import React, { useEffect, useState } from "react";
import { Form, Row, Tree, TreeDataNode } from "antd";
import Ring from "@/components/ui/Ring";
import type { DataTypeOption } from "@/state/actuals/commonEquityStore";

interface DataTypeFormProps {
  dataType: DataTypeOption;
  onDataTypeChange: (value: DataTypeOption) => void;
  dataTypeTreeData: TreeDataNode[];
}

const DataTypeForm: React.FC<DataTypeFormProps> = ({ dataType, onDataTypeChange, dataTypeTreeData }) => {
  const [selectedKey, setSelectedKey] = useState<string | null>(null);

  useEffect(() => {
    if (dataType) {
      setSelectedKey(dataType);
    }
  }, [dataType]);

  const handleSelect = (selectedKeys: React.Key[], info: any) => {
    if (selectedKeys.length === 0 || !info.node.isLeaf) {
      setSelectedKey((prev) => prev);
      return;
    }

    const key = selectedKeys[0].toString();
    setSelectedKey(key);
    onDataTypeChange(key);
  };

  return (
    <div>
      <Form.Item name="dataType" className="!mb-2">
        <Row align="top" className="!flex !flex-col gap-2 w-full">
          <Row>
            <label className="">Data Type:</label>
          </Row>
          <Row className="!w-full">
            <Ring className="w-full py-3 px-3">
              <Tree
                selectable
                selectedKeys={selectedKey ? [selectedKey] : []}
                onSelect={handleSelect}
                treeData={dataTypeTreeData}
                showLine={{ showLeafIcon: false }}
              />
            </Ring>
          </Row>
        </Row>
      </Form.Item>
    </div>
  );
};

export default DataTypeForm;
